import { useAuthStore } from '@store'
import MainLayout from './MainLayout'
import DashboardLayout from './DashboardLayout'

function SmartLayout() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  return isAuthenticated ? <DashboardLayout /> : <MainLayout />
}

export default SmartLayout
